import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Snackbar,
  Button,
  Box,
  Typography,
  IconButton,
  Paper
} from '@material-ui/core';
import { Refresh as RefreshIcon, Close as CloseIcon, Info as InfoIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  snackbar: {
    bottom: theme.spacing(2),
    left: theme.spacing(2),
    right: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      left: 'auto',
      right: theme.spacing(2),
      minWidth: 400,
    },
  },
  paper: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    minWidth: 300,
    borderRadius: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  message: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  updateButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

interface UpdatePromptProps {
  onUpdate: () => void;
  onDismiss: () => void;
  show: boolean;
}

const UpdatePrompt: React.FC<UpdatePromptProps> = ({ onUpdate, onDismiss, show }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  const handleUpdate = () => {
    onUpdate();
    setOpen(false);
  };

  const handleDismiss = () => {
    onDismiss();
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      className={classes.snackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      // No auto-hide, user must choose
    >
      <Paper className={classes.paper} elevation={6}>
        <InfoIcon className={classes.icon} />
        <Box className={classes.content}>
          <Box className={classes.message}>
            <Typography variant="body2" component="div">
              <strong>Nueva versión disponible</strong>
            </Typography>
            <Typography variant="caption" component="div">
              Hay una actualización de la aplicación lista para instalar
            </Typography>
          </Box>
          <Box className={classes.actions}>
            <Button
              size="small"
              variant="contained"
              className={classes.updateButton}
              startIcon={<RefreshIcon />}
              onClick={handleUpdate}
            >
              Actualizar
            </Button>
            <IconButton
              size="small"
              onClick={handleDismiss}
              style={{ color: 'inherit' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Paper>
    </Snackbar>
  );
};

export default UpdatePrompt;
